module.exports = __webpack_public_path__ + "static/media/bars.d5e245c1.svg";